import { render, staticRenderFns } from "./AlgCopyrightText.vue?vue&type=template&id=0644dcd1&scoped=true&"
import script from "./AlgCopyrightText.vue?vue&type=script&lang=js&"
export * from "./AlgCopyrightText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0644dcd1",
  null
  
)

export default component.exports